import moment from 'moment';
import { IEventsData, EventScoreType } from './EventsFeedInterfaces';
import { IEvent, ClusterRelatedArticle } from '../../interfaces';

export const MOCK_CLUSTER_QUERY_PARAM = 'is_show_mock_cluster_event';
export const MOCK_CLUSTER_EVENT_ID = 999999999;
export const MOCK_CLUSTER_ID = 'mock-cluster-999999999';

export const isShowMockClusterEvent = (search: string): boolean =>
    new URLSearchParams(search).has(MOCK_CLUSTER_QUERY_PARAM);

export const buildMockClusterEvent = (
    realEvents: IEventsData[]
): IEventsData => {
    const now = moment();
    const template = realEvents[0];
    return {
        id: MOCK_CLUSTER_EVENT_ID,
        headline: 'MOCK CLUSTER — visual test cluster event',
        source: 'Mock Source',
        countries: template?.countries ?? [],
        focus_countries: template?.focus_countries ?? [],
        mentioned_countries: [],
        url: template?.url ?? '',
        time: now,
        created_at: now,
        bullshit_metric: -1,
        cluster: {
            id: MOCK_CLUSTER_ID,
            article_count: MOCK_RELATED_ARTICLES.length,
            articles: MOCK_RELATED_ARTICLES,
        },
    };
};

const MOCK_RELATED_ARTICLES: ClusterRelatedArticle[] = [
    {
        id: 900000001,
        headline: 'Portugal heads to polls in first presidential vote since 2021',
        score_type: 'human',
    },
    {
        id: 900000002,
        headline: 'Marcelo Rebelo de Sousa deixa a presidência após uma década',
    },
    {
        id: 900000003,
        headline:
            "Portugal's election sets stage for second round amid fragmented vote",
    },
    ...Array.from({ length: 97 }, (_, i) => {
        const scoreTypes: (EventScoreType | undefined)[] = [
            'machine',
            'human',
            undefined,
        ];
        return {
            id: 900000004 + i,
            headline: `Portugal presidential election coverage — article ${i + 4}`,
            score_type: scoreTypes[i % scoreTypes.length],
        };
    }),
];

export const withMockCluster = (event: IEvent): IEvent => ({
    ...event,
    cluster: {
        id: MOCK_CLUSTER_ID,
        article_count: MOCK_RELATED_ARTICLES.length,
        articles: MOCK_RELATED_ARTICLES,
    },
});
